
import VueSlickCarousel from 'vue-slick-carousel'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'CharitySlider',
  components: {
    VueSlickCarousel,
  },
  setup () {
    const carousel = ref<any>(null)
    const currentSlideIndex = ref(0)
    const handleAfterChange = (current:number) => {
      currentSlideIndex.value = current
    }
    return {
      carousel,
      handleAfterChange,
      currentSlideIndex,
    }
  },
})
